import { generate } from '@/utils/request';
const config = {
  prefix: '/spur/v1/{organizationId}',
  items: [
    { key: 'orderPalletList', url: '/order-pallet/config', method: 'get' },
    { key: 'orderPalletAdd', url: '/order-pallet/config', method: 'post' },
    { key: 'orderPalletUpdate', url: '/order-pallet/config', method: 'put' },
    { key: 'orderPalletDelete', url: '/order-pallet/config/batch', method: 'delete' },
    { key: 'getorderPalletList', url: '/order-pallet/config/detail', method: 'get' },
  ],
};

export default {
  ...generate(config),
};
